import React from 'react';

import { Edit } from './Edit';
import { View } from './View/View';
import { List } from './List';

export const reviewsRoutes = {
  path: '/reviews',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: ':id/edit',
      element: <Edit />,
    },
    {
      path: ':id',
      element: <View />,
    },
  ],
};
